import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetAllFilter, setLimit } from "../RTK/Features/filter/filterSlice";
import { fetchTransactions } from "../RTK/Features/Transaction/TrnasactionSlice";
import Transaction from "./Transaction";
import { useNavigate, useMatch } from "react-router-dom";
function TransactionList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { transactions, loading, error, isError } = useSelector(
    (state) => state.transaction
  );
  let { searchTerm, transactionType, order, limit } = useSelector(
    (state) => state.filter
  );

  React.useEffect(() => {
    limit = 5;
    dispatch(
      fetchTransactions({
        searchTerm,
        transactionType,
        order,
        limit,
        balanceRequired: true,
      })
    );
  }, [
    dispatch,
    searchTerm,
    transactionType,
    order,
    limit,
    transactions.length,
  ]);

  const handleViewAll = () => {
    dispatch(setLimit(10));
    navigate("/alltransactions");
  };

  let content = null;

  if (loading) content = <p className="text-slate-300">Loading...</p>;
  if (!loading && error && isError)
    content = (
      <p className="text-slate-300">
        Something went wrong,please try again later
      </p>
    );
  if (!loading && !error && !isError && transactions.length === 0) {
    content = <p className="text-slate-300">There is no transaction to show</p>;
  }
  if (!loading && !error && !isError && transactions.length > 0) {
    content = (
      <>
        <div className="w-full h-full flex flex-col items-center justify-center pb-4 text-slate-300">
          <p>Your Transactions</p>
        </div>

        <div className="w-full h-full flex flex-col items-center justify-center mb-8 gap-4">
          {transactions.map((transaction) => (
            <Transaction key={transaction.id} transaction={transaction} />
          ))}
        </div>
        {transactions.length >= 5 && (
          <div className="w-full h-full flex  items-center justify-end mb-8 w-[400px]">
            <div
              onClick={handleViewAll}
              className="flex w-1/3 items-center justify-center  p-2 bg-sky-700	hover:bg-sky-800 active:bg-sky-900 text-slate-300"
            >
              <button>View All</button>
            </div>
          </div>
        )}
      </>
    );
  }

  return content;
}

export default TransactionList;
